import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const InputFileUpload = ({ field }) => {
    const {
        name,
        label,
        value,
        onChange,
        required,
        readOnly,
        tooltip,
        fieldWidth,
        acceptedFormats,
        maxFileSize, // in MB
        renderTable,
        errorMsgs,
        actionClicked,
        upperClass
    } = field;

    const fileRef = useRef(null);
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
        // No value
        if (!value) {
            if (required && !renderTable) {
                setErrorMsg(errorMsgs?.required || `${label} is required`);
            } else {
                setErrorMsg("");
            }
            return;
        }

        // View mode → value is string (filename / URL)
        if (typeof value === "string") {
            setErrorMsg("");
            return;
        }

        // File type validation
        if (acceptedFormats) {
            const allowedTypes = acceptedFormats.split(",");
            const isValidType = allowedTypes.some(type =>
                value.name.toLowerCase().endsWith(type.trim())
            );
            if (!isValidType) {
                setErrorMsg(errorMsgs?.type || "Invalid file format");
                return;
            }
        }

        // File size validation
        if (maxFileSize) {
            const sizeInMB = value.size / (1024 * 1024);
            if (sizeInMB > maxFileSize) {
                setErrorMsg(
                    errorMsgs?.size || `File size should not exceed ${maxFileSize} MB`
                );
                return;
            }
        }

        setErrorMsg("");
    }, [value, required, renderTable]);

    const handleFileChange = (e) => {
        const file = e.target.files?.[0] || null;
        onChange(file);
    };

    return (
        <div
            style={{ position: "relative" }}
            className={"form-group " + upperClass + " my-2"}
        >
            {label && (
                <label htmlFor={name} style={{ width: "25%" }}>
                    {label}
                    <span className="required_mark">{required ? " *" : null}</span>
                </label>
            )}

            <div className={"w-" + (fieldWidth ?? "75") + " d-inline-block mx-2"}>




                <>
                    <input
                        ref={fileRef}
                        type="file"
                        id={name}
                        name={name}
                        onChange={handleFileChange}
                        title={tooltip}
                        className="form-control rounded-2"
                        accept={acceptedFormats}
                    />

                    {value instanceof File && (
                        <small className="text-muted d-block mt-1">
                            Selected file: {value.name}
                        </small>
                    )}


                    {typeof value === "string" && value && (
                        <small className="text-muted d-block mt-1">
                            Uploaded file: {value}
                        </small>
                    )}


                </>


                {errorMsg && actionClicked && (
                    <p className="text-danger errorMsg">{errorMsg}</p>
                )}
            </div>
        </div>
    );
};

InputFileUpload.propTypes = {
    field: PropTypes.object.isRequired,
};

export default InputFileUpload;
